export default __webpack_public_path__ + "static/media/escudo.e9c12c7f.jpg";